import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const vueRouter = new Router({
    routes: [
        {
            path: '/',
            redirect: '/index'
        },
        {
            path: '/index',
            name: 'index',
            meta: {
                title: '首页',
                keepAlive: true,
            },
            hidden: true,
            component: () => import('@/views/index')
        },
        {
            meta: {
                title: '数据产品查询',
                keepAlive: true,
            },
            hidden: true,
            path: '/productInquiry',
            name: 'productInquiry',
            component: () => import('@/views/productInquiry/index')
        },
        {
            meta: {
                title: '数据详情',
            },
            hidden: false,
            path: '/productDetail',
            name: 'productDetail',
            component: () => import('@/views/productInquiry/detail')
        },
        {
            path: '/newsList',
            hidden: true,
            name: 'newsList',
            meta: {
                title: '行业信息',
            },
            component: () => import('@/views/newsList/index'),
        },
        {
            meta: {
                title: '新闻详情',
            },
            hidden: true,
            path: '/listDetail',
            name: 'listDetail',
            component: () => import('@/views/newsList/detail')
        },
        {
            meta: {
                title: '政策法规',
            },
            hidden: true,
            path: '/normalLaw',
            component: () => import('@/views/normalLaw/index'),
        },
        {
            path: '/research',
            name: 'research',
            component: () => import('@/views/research/index'),
        },
        {
            path: '/knowledge',
            name: 'knowledge',
            component: () => import('@/views/knowledge/index')
        },
        {
            path: '/about',
            name: 'about',
            component: () => import('@/views/about/index')
        },
        {
            path: '/activity',
            name: 'activity',
            component: () => import('@/views/activity/index')
        },
        {
            path: '/form',
            name: 'form',
            component: () => import('@/views/activity/form')
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    }
})


export default vueRouter
